import { KRDS } from '~/components/charts'
import { type BadgeTone } from '~/components/ui/badge'

// 사용자/조직/권한 (DESIGN.md §5.1 /admin/users).
export type UserStatus = 'pending' | 'active' | 'rejected'

export interface UserRow {
    id: string
    email: string
    name: string
    role: string
    active: boolean
    // 가입 승인 상태(pending=신청 대기). 없으면 active로 간주한다.
    status?: UserStatus
    // 백엔드가 내려주면 표시(조직·가입일). 없으면 자연스럽게 생략한다.
    organization?: string | null
    createdAt?: string | null
}

// 역할 변경 확인 대기 상태.
export interface PendingRole {
    user: UserRow
    role: string
}

// 가입 승인/거부 확인 대기 상태.
export interface PendingStatus {
    user: UserRow
    status: 'active' | 'rejected'
}

// 가입 상태 배지: pending=주의, active=성공, rejected=위험.
export const STATUS_TONE: Record<UserStatus, BadgeTone> = {
    pending: 'warning',
    active: 'success',
    rejected: 'danger',
}
export const STATUS_LABEL: Record<UserStatus, string> = {
    pending: '승인 대기',
    active: '활성',
    rejected: '거부',
}

// 역할 표시 순서·의미색·라벨. superadmin=위험(point), admin=주의(warning), user=중립.
export const ROLE_ORDER = ['user', 'admin', 'superadmin'] as const
export const ROLE_TONE: Record<string, BadgeTone> = {
    user: 'neutral',
    admin: 'warning',
    superadmin: 'point',
}
export const ROLE_FILL: Record<string, string> = {
    user: KRDS.gray[40],
    admin: KRDS.warning,
    superadmin: KRDS.point,
}

export function formatDate(iso?: string | null): string {
    if (!iso) return '-'
    const d = new Date(iso)
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('ko-KR')
}
